import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatBoxMessage = _resolveComponent("ChatBoxMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: _ctx.$t('pusatResolusi.finish.title'),
        message: "",
        image: "ill_spot_info_tnc",
        textSuccess: _ctx.$t('pusatResolusi.finish.sendAndFinish'),
        textCancel: _ctx.$t('pusatResolusi.finish.cancel'),
        class: "px-8",
        customWidth: "800px",
        onClose: _ctx.onCloseModal,
        onSubmit: _ctx.onSubmitModal,
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        imageWidth: 36,
        imageHeight: 36
      }, {
        custom: _withCtx(() => [
          _createVNode(_component_ChatBoxMessage, {
            modelValue: _ctx.message,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.message = $event)),
            isSendButton: false
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title", "textSuccess", "textCancel", "onClose", "onSubmit"]))
    : _createCommentVNode("", true)
}